import { render } from "./OperatePickingForm.vue?vue&type=template&id=2c36580c"
import script from "./OperatePickingForm.vue?vue&type=script&lang=js"
export * from "./OperatePickingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__